import { isEmpty } from "lodash";
import { DEVELOPMENT, LOCAL_TRADE_MAP_URL, PRODUCTION } from "./const";

export function getTradeMapUrl() {
  const REACT_ENV = import.meta.env.VITE_HOST_ENV;
  const TRADE_MAP_URL = !!import.meta.env.VITE_TRADE_MAP_URL && import.meta.env.VITE_TRADE_MAP_URL !== "" ? import.meta.env.VITE_TRADE_MAP_URL : LOCAL_TRADE_MAP_URL;
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return TRADE_MAP_URL;
      case PRODUCTION:
        return TRADE_MAP_URL;
      default:
        return TRADE_MAP_URL;
    }
  } else {
    return LOCAL_TRADE_MAP_URL;
  }
}
